// Figma: "White Card" (e.g. node 18050:154) — white, 12px radius, hairline border, soft
// shadow. Every login-flow screen state is this same card with different content inside.
import React from 'react';
import PropTypes from 'prop-types';
import {Paper} from '@mui/material';
import {tokens} from '../../../themes/ThemeCustomization';

const AuthCard = ({children, gap = '36px'}) => (
    <Paper
        elevation={0}
        sx={{
            width: '100%',
            backgroundColor: tokens.color.white,
            border: `1px solid ${tokens.color.neutral100}`,
            borderRadius: tokens.radius.card,
            boxShadow: tokens.shadow.card,
            px: 4,
            py: 5,
            display: 'flex',
            flexDirection: 'column',
            gap
        }}
    >
        {children}
    </Paper>
);

AuthCard.propTypes = {
    children: PropTypes.node,
    gap: PropTypes.string
};

export default AuthCard;
